<style lang="less">
  @import "./SendAudio.less";
</style>

<template>
  <div class="send-audio">
    <van-cell-group>
      <!--<van-cell title="IMEI" icon="setting-o" :value="nowImei" is-link @click="toChangeDevPageFn" />-->
      <van-cell title="IMEI" icon="setting-o" :value="nowImei" />
    </van-cell-group>
    <h4 class="gray-color">信息将转换为语音直接发送至该设备</h4>
    <!--<van-cell-group>-->
      <!--<van-field-->
        <!--v-model="messageValue"-->
        <!--type="textarea"-->
        <!--placeholder="请输入信息"-->
        <!--rows="5"-->
        <!--maxlength="100"-->
        <!--autosize-->
      <!--/>-->
    <!--</van-cell-group>-->
    <div class="send-audio-textarea">
      <van-field
        v-model="messageValue"
        type="textarea"
        placeholder="请输入信息"
        rows="5"
        maxlength="100"
        autosize
      />
    </div>
    <div class="page-btn">
      <van-button type="info" size="large" @click="sendAudioFn">发送信息</van-button>
      <van-button type="info" size="large" plain @click="toHomePageFn">返回首页</van-button>
    </div>
  </div>
</template>

<script>
import SendAudio from './SendAudio.js'
export default {
  ...SendAudio
}
</script>
